import Vue from 'vue'
import Vuex from 'vuex'

import {getAllDicts} from "@/api/common"
import {getInfo} from "@/api/login"

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user:{},
    token:"",
    testvuex: false,
    hasLogin:false,
    kpht:{},
    dicts:[],
    permissions: [],
    roles:[],
  },
  mutations: {
    login(state, user) {
      state.hasLogin = true;
      state.user = user;
    },
    SET_USER(state,user){
      state.user = user;
    },
    SET_TOKEN(state,token){
      state.token = token;
    },
    SET_KPHT(state,kpht){
      state.kpht = kpht
    },
    SET_DICTS(state,dicts){
      state.dicts = dicts
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions

    },
    SET_ROLES: (state, roles) => {
      state.roles = roles

    },

  },
  getters: {
     dicts:state=>state.dicts,
      kpht:state=>state.kpht,
      user:state=>state.user,
      token:state=>state.token,
      permissions: state => state.permissions,
  },
  actions: {
    setkpht({ commit, state },kpht){
      commit('SET_KPHT',kpht)
    },
    setToken({commit,state},token){
      commit('SET_TOKEN',token)
    },
    getDicts({commit,state}){
      return new Promise((resolve,reject)=>{
        getAllDicts().then(res=>{
          commit('SET_DICTS',res.data)
          resolve(res)
        }).catch(res=>{

          reject(res)
        })
      })

    },
    // 获取用户信息
    getInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
    		console.log("getInfo:",res)
          const user = res.user
          commit('SET_USER', res.user)

          if (res.roles && res.roles.length > 0) {
            commit('SET_ROLES', res.roles)
            commit('SET_PERMISSIONS', res.permissions)
          } else {
            commit('SET_ROLES', ['ROLE_DEFAULT'])
          }

          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },


  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js